import styled from "styled-components";

export const StyledFormWrapper = styled.div<{$borderless?: boolean}>`
  border: ${({$borderless}) => ($borderless ? "none" : "1px solid #f0f0f0")};
  background-color: #fff;
  /* box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05); */
  border-radius: 10px;
  padding: 1.6rem;

  @media only screen and (max-width: 450px) {
    padding: 1.6rem;
    border: none;
    box-shadow: none;
    border-radius: 0;
  }
`;
export const StyledFormWrapperHeading = styled.div`
  .main-heading {
    font-weight: 700;
    font-size: 2.4rem;
  }

  .sub-heading {
    font-weight: 400;
    font-size: 1.4rem;
    margin-top: 2rem;
  }

  .info-block {
    background-color: #f5edff;
    border-radius: 5px;
    padding: 1rem;

    margin-top: 2rem;

    .info-block-text {
      font-weight: 400;
      font-size: 1.2rem;
    }
  }
`;
